import type { IChapter, IFacilitatorSuggestion } from "@lexicanon/shared"
import type { IMeetingAnalysis, IMeetingDetail } from "../../../lib/types/meeting"

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value)
}

function isCoachSuggestion(value: unknown): value is IFacilitatorSuggestion {
  if (!isRecord(value)) return false
  return typeof value.question === "string" && typeof value.why === "string"
}

function isChapter(value: unknown): value is IChapter {
  if (!isRecord(value)) return false
  return typeof value.title === "string" && typeof value.start_offset === "number"
}

/**
 * When a translation is active the translated payload carries `coach_suggestions`
 * and `chapters` alongside the analysis. Fall back to the raw meeting fields.
 */
export function displayCoachSuggestions(analysis: IMeetingAnalysis, meeting: IMeetingDetail): IFacilitatorSuggestion[] {
  const extra: unknown = analysis
  if (isRecord(extra) && Array.isArray(extra.coach_suggestions)) {
    return extra.coach_suggestions.filter(isCoachSuggestion)
  }
  return meeting.coach_suggestions ?? []
}

export function displayChapters(analysis: IMeetingAnalysis, meeting: IMeetingDetail): IChapter[] | undefined {
  const extra: unknown = analysis
  if (isRecord(extra) && Array.isArray(extra.chapters)) {
    const chapters = extra.chapters.filter(isChapter)
    if (chapters.length > 0) return chapters
  }
  return meeting.chapters
}
